import React, { CSSProperties } from 'react';
import { ObjectId } from 'bson';
import './Ping.scss';

const Ping = ({ style }: { style: CSSProperties, ping: { x: number, y: number, _id: ObjectId } }) => {
    return (
        <div className="ping" style={style} >
        </div>
    );
};
export default Ping;
